<template>
    <div class="permissions">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.permissions || "Permissions" }}</h2>
            </div>
        </div>
        <div class="grid-3">
            <div class="checkbox-group">
                <p class="column-title">{{ $page.props.lang.calendar || "Calendar" }}</p>
                <v-checkbox v-for="(item,index) in permissionsData.filter(perm => perm.name.startsWith('calendar'))"
                :key="index"
                :label="item.title"
                v-model="item.value"
                hide-details></v-checkbox>
            </div>
            <div class="checkbox-group">
                <p class="column-title">{{ $page.props.lang.member || "Member" }}</p>
                <v-checkbox v-for="(item,index) in permissionsData.filter(perm => perm.name.startsWith('member'))"
                :key="index"
                :label="item.title"
                v-model="item.value"
                hide-details></v-checkbox>
            </div>
            <div class="checkbox-group">
                <p class="column-title">{{ $page.props.lang.general || "General" }}</p>
                <v-checkbox v-for="(item,index) in permissionsData.filter(perm => (!perm.name.startsWith('calendar') && !perm.name.startsWith('member')))"
                :key="index"
                :label="item.title"
                v-model="item.value"
                hide-details></v-checkbox>
            </div>
        </div>
        <div class="btn-wrap">
            <v-btn @click="savePermissions" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import TrainerLayout from './Layouts/Default'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.permissions || "Trainer permissions"
        }
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(TrainerLayout, [page]),
      ])
    },
    props: {
        trainer: Object,
        lang: Object,
        permissions: Array,
    },
    data() {
        return {
            form: this.trainer,
            messageObjects: []
        }
    },
    computed: {
        userPermissions() {
            let userPerm = []
            userPerm = this.p.map(item => {
                let pair = {}
                pair[item.name]=item.value
                return pair
            })
            return Object.assign(...userPerm)
        },
        permissionsData() {
            return this.permissions.map(item => {
                let permission = {}
                permission['name']=item.name
                permission['value']=item.value
                let titleEdit = function(arg) {
                    return arg.charAt(0).toUpperCase() + arg.split('.').join(' ').slice(1)
                }
                let nm = item.name
                let lg = this.lang

                nm === 'members.read' ? permission['title'] = lg.membersRead || titleEdit(nm.replace('members.', '')) : ''
                nm === 'members.remove' ? permission['title'] = lg.membersRemove || titleEdit(nm.replace('members.', '')) : ''
                nm === 'members.manage' ? permission['title'] = lg.membersManage || titleEdit(nm.replace('members.', '')) : ''
                nm === 'members.payments.make' ? permission['title'] = lg.membersPaymentsMake || titleEdit(nm.replace('members.', '')) : ''
                nm === 'members.payments.read' ? permission['title'] = lg.membersPaymentsRead || titleEdit(nm.replace('members.', '')) : ''
                nm === 'calendar.own.read' ? permission['title'] = lg.calendarOwnRead || titleEdit(nm.replace('calendar.', '')) : ''
                nm === 'calendar.own.manage' ? permission['title'] = lg.calendarOwnManage || titleEdit(nm.replace('calendar.', '')) : ''
                nm === 'calendar.own.complete' ? permission['title'] = lg.calendarOwnComplete || titleEdit(nm.replace('calendar.', '')) : ''
                nm === 'calendar.all.read' ? permission['title'] = lg.calendarAllRead || titleEdit(nm.replace('calendar.', '')) : ''
                nm === 'calendar.all.manage' ? permission['title'] = lg.calendarAllManage || titleEdit(nm.replace('calendar.', '')) : ''
                nm === 'calendar.all.complete' ? permission['title'] = lg.calendarAllComplete || titleEdit(nm.replace('calendar.', '')) : ''
                nm === 'settings' ? permission['title'] = lg.settings || titleEdit(nm) : ''
                nm === 'trainers' ? permission['title'] = lg.trainers || titleEdit(nm) : ''
                nm === 'reports' ? permission['title'] = lg.reports || titleEdit(nm) : ''
                nm === 'finance' ? permission['title'] = lg.finance || titleEdit(nm) : ''
                nm === 'pos' ? permission['title'] = lg.pos || titleEdit(nm) : ''

                return permission
            })
        }
    },
    methods: {
        savePermissions() {
            let perms = {}
            this.permissionsData.map(item => {
                perms[item.name]=item.value
            })
            axios.post('/backoffice/trainers/storePermission', {trainer_id: this.trainer.id, permissions: perms})
                .then(response => {
                    if(response.data.status==="OK") {
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        }
    }
}
</script>
